<template lang="pug">
.ModelsHistory
  //.ModelsHistory-filter
    quick-filter(@filter='filterHistory')
  .ModelsHistory-list.List(v-if='versions && versions.length')
    .List-version.Version(v-for='version in versions')
      .Version-header.Pointer(
        @mouseover.stop='toggleVersionHeaderHelperText(version)',
        @mouseout.stop='helperText = null',
        @click='toggleVersion(version)'
      )
        i.Icon.IconChevronRight(v-if='!opened[version.id]')
        i.Icon.IconChevronDown--v2(v-else)
        span.Version-title Версия № {{ version.version }}
        span.Version-action(
          v-if='version.version !== $store.getters.version',
          @click='activateVersion($event, version.id)'
        )
          i.Icon.IconRepeat
          span.Version-tooltip.OneLine Восстановить эту версию
      .Version-body(v-if='opened[version.id]')
        template(v-for='(item, index) in version.history')
          .Version-date(v-if='!index || item.dateText !== version.history[index - 1].dateText') {{ item.dateText }}
          .Version-item.Item(:class='{ "Item--logsShown": item.task_id === openedLogId }')
            span.Item-status
              i.Icon.IconModelingSuccess(v-if='item.status === "finished"')
              i.Icon.IconModelingFail(v-if='item.status === "error"')
              i.Icon.IconModelingStarted(v-if='item.status === "working"')
              i.Icon.IconModelingProgress(v-if='item.status === "new"')
            span.Item-time {{ item.createdTime }}
            span.Item-text {{ item.name }}
            button.Btn.BtnIcon(
              v-if="item.task_id"
              @click='toggleLog(item.task_id)',
              @mouseover.stop='toggleProcessLogHelperText(item.task_id)',
              @mouseout.stop='helperText = null'
            )
              i.Icon.IconLog
          log.Version-log(
            v-if='item.task_id === openedLogId',
            :isLoading='!logs[openedLogId]',
            :text='logs[openedLogId] ? logs[openedLogId].log || "" : ""',
            :errors='logs[openedLogId] ? logs[openedLogId].error || "" : ""'
          )
        .Version-more(v-if='version.count > version.history.length')
          a.Pointer(@click='loadHistory(version)') Следующие
</template>

<script>
import Vue from 'vue'
import QuickFilter from '@/components/Filter.vue'
import Log from '@/components/modeling/Log.vue'
import helpertext from '@/mixins/helpertext'

export default {
  name: 'modeling-history',

  mixins: [helpertext],

  components: {
    QuickFilter,
    Log
  },

  data() {
    return {
      opened: {},
      loading: {},
      openedLogId: -1,
      timeInterval: null
    }
  },

  computed: {
    versions() {
      return this.$store.getters.versionList
    },
    workspace() {
      return this.$store.getters.workspace
    },
    version() {
      return this.$store.getters.version
    },
    activeVersionObject() {
      const currentVersionObject = this.versions.filter((v) => v.version === this.version)
      return currentVersionObject.length > 0 ? currentVersionObject[0] : null
    },
    logs() {
      return this.$store.getters.modelingLogs
    }
  },

  watch: {
    workspace(newVal) {
      this.opened = {}
      this.loading = {}
    }
  },

  mounted() {
    this.timeInterval = setInterval(() => {
      if (this.activeVersionObject && this.opened[this.activeVersionObject.id]) {
        this.loadHistory(this.activeVersionObject, true)
      }
    }, 10000)
  },

  beforeDestroy() {
    clearInterval(this.timeInterval)
    this.timeInterval = null
  },

  methods: {
    toggleLog(id) {
      if (!id) {
        return
      }

      this.openedLogId = this.openedLogId === id ? -1 : id
      this.toggleProcessLogHelperText(id)
      if (!this.logs[id]) {
        this.$store.dispatch('getModelingLogs', id)
      }
    },
    toggleVersion(version) {
      Vue.set(this.opened, version.id, !this.opened[version.id])
      this.toggleVersionHeaderHelperText(version)
      if (this.opened[version.id]) {
        if (version.count === -1) {
          this.loadHistory(version)
        } else if (version.version === this.version) {
          this.loadHistory(version, true)
        }
      }
    },
    loadHistory(version, updateFirst = false) {
      if (!this.loading[version.id]) {
        Vue.set(this.loading, version.id, true)
        this.$store
          .dispatch('getModelingHistory', {
            version: version.version,
            updateFirst
          })
          .then((v) => {
            Vue.set(this.loading, version.id, false)
          })
      }
    },
    filterHistory(value) {
      console.log('filter', value)
    },

    activateVersion(e, version) {
      e.stopImmediatePropagation()
      this.$store.dispatch('activateVersion', version)
    },

    toggleVersionHeaderHelperText(version) {
      this.helperText = this.opened[version.id] ? 'Свернуть историю действий' : 'Развернуть историю действий'
    },

    toggleProcessLogHelperText(logId) {
      this.helperText = this.openedLogId === logId ? 'Скрыть отчет о запуске' : 'Показать отчет о запуске'
    }
  }
}
</script>
<style lang="scss">
@import '~base';

#app .ModelsHistory {
  --tooltipBg: #{$white2};
}

#app[data-theme='dark'] .ModelsHistory {
  --tooltipBg: #{$black3};
}
</style>
<style scoped lang="scss">
@import '~base';
.Scroll {
  max-height: 100%;
  min-height: 100%;
}

.ModelsHistory {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  color: var(--basicText);

  &-filter {
    flex: 0 0 auto;
  }

  &-list {
    flex: 1 1 auto;
    overflow: auto;
    height: 0;
  }
}

.Version {
  &-more {
    margin: 15px 0 0 15px;

    a {
      color: $blue;
      font-size: 13px;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }
  &-log {
    margin: 10px 0 10px 15px;
  }
  &-body {
    margin: 0 10px 15px 25px;
  }
  &-header {
    position: relative;
    padding: 13px 15px;
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;

    &:hover {
      border-color: var(--delimiter);
    }

    .Icon {
      margin-right: 10px;
      font-size: 14px;
      color: var(--secondaryText);
    }
  }
  &-title {
    font-size: 14px;
    font-weight: 500;
  }
  &-date {
    margin: 20px 15px 15px;
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
  }

  &-tooltip {
    display: none;
    position: absolute;
    right: -2px;
    top: 100%;
    margin-top: 7px;
    padding: 2px 12px 2px 12px;
    border-radius: 4px;
    background: var(--tooltipBg);
    color: var(--basicText);
    z-index: 2;
    font-size: 13px;
    box-shadow: 0px 4px 5px rgba(59, 66, 86, 0.2);
  }

  &-action:hover &-tooltip {
    display: block;
  }

  &-action {
    display: none;
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -11px;
    color: var(--secondaryText);

    .Icon {
      margin-right: 0;
      font-size: 20px;
    }
  }

  &:hover &-action {
    display: block;
  }
}

.Item {
  display: flex;
  position: relative;
  width: 100%;
  padding: 6px 25px 6px 15px;
  font-size: 13px;

  &-time {
    flex: 0 0 auto;
  }

  &-text {
    flex: 1 1 auto;
    padding-left: 15px;
    color: var(--secondaryText);
  }

  button {
    position: absolute;
    right: 0;
    top: -2px;
    opacity: 0;
    color: var(--secondaryText);
  }

  &:hover,
  &--logsShown {
    button {
      opacity: 1;
    }
  }

  &--logsShown:hover,
  &--logsShown {
    button {
      color: $blue;
    }
  }

  &-status {
    position: absolute;
    top: 50%;
    left: -16px;
    margin-top: -12px;
    flex: 0 0 auto;
    width: 24px;
    margin-right: 4px;

    .Icon {
      display: block;
      font-size: 22px;
      width: 24px;
      height: 24px;
      line-height: 22px;
      border: 1px solid;
      border-radius: 50%;
      text-align: center;
    }

    .IconModelingSuccess {
      color: $green;
      border-color: $green;
    }

    .IconModelingStarted {
      color: $blue;
      border: 0;
      font-size: 24px;
    }

    .IconModelingFail {
      color: $red;
      border-color: $red;
    }

    .IconModelingEmpty {
      color: $grey1;
      border-color: $grey1;
    }

    .IconModelingProgress {
      color: var(--basicText);
      border-color: var(--basicText);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modeling/History.vue